import { useState } from 'react';
import { Alert, Card, Col, Form, Row } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import { useTranslation } from 'react-i18next';
import { LANGUAGES } from 'utils';
import { Genre } from '../models/Genre';

interface Preview {
  show: boolean;
  handleCloseModalPreview: () => void;
  genre: Genre;
  defaultLang?: string;
}

function ModalPreView({ show, handleCloseModalPreview, genre, defaultLang = 'ja' }: Preview) {
  const { t } = useTranslation();
  const languages: any = {
    ja: genre.display_name_ja,
    en: genre.display_name_en,
    zh_hant: genre.display_name_zh_hant,
    zh_hans: genre.display_name_zh_hans,
    ko: genre.display_name_ko,
    vi: genre.display_name_vi,
  };
  const [choose_language, setChooseLanguage] = useState<string>(defaultLang);

  function handleChangeLange(event: any) {
    const lang = event.target.value;
    setChooseLanguage(lang);
  }

  function handleClose() {
    setChooseLanguage(defaultLang);
    handleCloseModalPreview && handleCloseModalPreview();
  }

  return (
    <Modal show={show} onHide={handleClose} backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>{t('ModalSearch.title')}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group as={Row} className="mb-3">
          <Col sm={4} md={4} lg={4} xl={4}>
            {t('ModalSearch.language')}
          </Col>
          <Col sm={4} md={4} lg={4} xl={4}>
            <Form.Select onChange={handleChangeLange} defaultValue={languages[choose_language]}>
              {Object.entries(LANGUAGES).map(([key, value]) => {
                return (
                  <option key={key} value={key}>
                    {value}
                  </option>
                );
              })}
            </Form.Select>
          </Col>
        </Form.Group>
        <Form.Group as={Row} className="mb-3">
          <Col>
            <Card>
              <Card.Body>
                {genre && typeof genre.background_img === 'string' && genre.background_type.toString() === '1' && (
                  <Card.Img
                    variant="top"
                    src={
                      genre?.background_img && genre?.background_img.length > 0
                        ? process.env.REACT_APP_IMAGE_URL + genre?.background_img
                        : ''
                    }
                  />
                )}
                {genre && typeof genre.background_color === 'string' && genre.background_type.toString() === '0' && (
                  <Alert
                    key="danger"
                    variant="light"
                    style={{
                      textAlign: 'center',
                      backgroundColor: genre.background_color,
                      height: 45,
                      color: '#ffffff',
                    }}
                  >
                    {languages[choose_language]}
                  </Alert>
                )}
                {genre && typeof genre.background_img === 'string' && genre.background_type.toString() === '1' && (
                  <Card.Text>{languages[choose_language]}</Card.Text>
                )}
              </Card.Body>
            </Card>
          </Col>
        </Form.Group>
      </Modal.Body>
    </Modal>
  );
}

export default ModalPreView;
